<template lang="html">
  <div class="mstablelist global__scrollcustom">
    <div v-if="isLoading">
      <half-circle-spinner
        :animation-duration="750"
        :size="100"
        color="#1D3354"
        class="mx-auto"/>
    </div>
    <div :class="`mstablelist__history ${detail.freightMode === 'OCEAN' ? 'th_bluecorporite' : detail.freightMode === 'AIR' ? 'th_purplecorporite' : detail.freightMode === 'LAND' ? 'th_deepgreen' : '' }`" v-else>
      <b-table
        sticky-header
        no-border-collapse
        responsive
        striped
        :items="items"
        :fields="fields"
      >
        <template v-slot:head()="scope">
          <div class="text-nowrap">
            {{ scope.label.toUpperCase() }}
          </div>
        </template>
        <template v-slot:table-caption v-if="!items || items.length === 0">
          <i>There is No List History</i>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { HalfCircleSpinner } from 'epic-spinners'
import mixinDateTime from '@/mixin/getters/date-time'

export default {
  name: 'MsHistory',
  components: {
    HalfCircleSpinner
  },
  mixins: [mixinDateTime],
  data () {
    return {
      shipmentId: this.$route.params.id_shipment,
      orderNumber: this.$route.params.order_number,
      fields: [
        'no.',
        'dateAndTime',
        'activity'
      ],
      items: []
    }
  },
  computed: {
    ...mapGetters({
      detail: 'shipment/item',
      history: 'shipment/history',
      isLoading: 'shipment/isLoadingHistory',
      isError: 'shipment/errorHistory'
    })
  },
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      const { shipmentId } = this
      const { orderNumber } = this
      await this.$store.dispatch('shipment/FETCH_SHIPMENT_HISTORY', { shipmentId, orderNumber })
      await this.getItems()
    },
    getItems () {
      return new Promise((resolve) => {
        this.items = []
        if (this.history) {
          this.history.forEach((item, index) => {
            const newItem = {
              no: `${index + 1}.`,
              dateAndTime: `${this.getDateDefauld(item.createdAt)} ${this.getTimeFormat1(item.createdAt)}`,
              activity: item.description
            }
            this.items.push(newItem)
          })
        }
        return resolve()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/managementShipment/detail/MsHistory.vue